import type { HTMLAttributes, ReactNode } from 'react'

import { colors } from '@/styles/colors'

import styles from './styles.module.scss'

export interface IconProps extends HTMLAttributes<HTMLDivElement> {
  color?: keyof typeof colors
  icon: ReactNode
  size?: string
}

export function Icon({ icon, color, size, className, ...props }: IconProps) {
  const iconColor = color && colors[color]
  return (
    <div
      {...props}
      className={[className, styles.container].join(' ')}
      style={{ color: iconColor, width: size, height: size }}
    >
      {icon}
    </div>
  )
}
